import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateService, TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-ema-confirm-dialog',
    templateUrl: './ema-confirm-dialog.component.html',
    styleUrls: ['./ema-confirm-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [MatDialogModule, MatButtonModule, MatIconModule, TranslateModule]
})
export class EmaConfirmDialogComponent {
  servers: string[];

  constructor(
    private translate: TranslateService,
    public dialogRef: MatDialogRef<EmaConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.servers = data.servers ?? [];
  }

  cancel() {
    this.dialogRef.close(false);
  }

  confirm() {
    this.dialogRef.close(true);
  }

  get serversText(): string {
    if (!this.servers || this.servers.length === 0) return '';
  
    if (this.servers.length === 1) return this.servers[0];
  
    const last = this.servers[this.servers.length - 1];
    const rest = this.servers.slice(0, -1).join(', ');
  
    const andWord = this.translate.instant('AND');
  
    return rest + ' ' + andWord + ' ' + last;
  }
}
